<script>
    import Axios from 'axios'
    import config from '../../../libs/config.js';
    import api from '../../../api'
    import { mapGetters, mapActions } from 'vuex'
    import _ from 'lodash'
    import _system from '../../../libs/system'	

    import { removeChannel } from '../mixins/removeChannel'

    import iziToast from 'izitoast'
    import 'izitoast/dist/css/iziToast.min.css';

	export default 
	{
        name: 'accountsGooglePlay',
        mixins: [ removeChannel ],     
        data() {
        	return {
                config: config,
                showEditPageName: false,
                appId: '',
                secret: '',
                clientId: '',
                code:'',
                pages: [],
                loader: true,
                mode: ''
        	}
        },
        computed: 
	    {
	        ...mapGetters('session', ['isLoggedIn','getUser', 'getRole','getJwt']),
            ...mapGetters('accounts', ['accounts']),
            ...mapGetters('tags', ['tagsByName']),        
            ...mapGetters('workspaces', ['currentWorkspace']),
            ...mapGetters('workspaceusers', ['workspaceusers']),
            ...mapGetters('networks', ['networks','networksByName']),
            codeTrimmed() {
                return this.code.trim();
            }
        },
        methods: {
            ...mapActions('accounts', ['setAccounts', 'removeChannel']),
            ...mapActions('networks', ['setNetworks']),
            reAuth(){
               document.getElementById("auth").submit(); 
            },        
            updateChannelName(account){
                if(account.name.length == 0){ return alert('Input cannot be empty!')}
                let payload = {
                        query: {
                            pageId: account._id
                        },
                        body: {
                            name: account.name
                        }
                    }
                    _system.services.accounts.update(payload, (err, updatedChannel) => {
                        if(err) return alert('Something, went wrong!');
                        iziToast.success({
                            position: 'bottomCenter',
                            title: 'Saved ✅',
                        });
                    });  
            },        
            update_status(e, pageId){
                if(!e.target.checked) {
                    let payload = {
                        query: {
                            pageId: pageId
                        },
                        body: {
                            tagId: this.tagsByName['Passive']._id
                        }
                    }
                    _system.services.accounts.setTag(payload, (err, updatedChannel) => {
                        this.accounts[_.findIndex(this.accounts, { _id: pageId })] = updatedChannel
                    });                   
                }else{
                    console.log('aga')
                    let payload = {
                        query: {
                            pageId: pageId,
                            tagId: this.tagsByName['Passive']._id
                        }
                    }
                    _system.services.accounts.deleteTag(payload, (err, updatedChannel) => {
                        this.accounts[_.findIndex(this.accounts, { _id: pageId })] = updatedChannel
                    });
                }

            }              
        },
        mounted(){
            $('.ui.dropdown').dropdown({
                transition: 'scale'
              })
        },
        created(){
            //Store Fetching
            if(this.accounts && this.networks){
                this.pages = _.filter(this.accounts, (e) => { return e.platform == this.networksByName['Google Play']._id }); 
                this.loader = false;
            }  

            console.log('under cat:', this.pages)

            this.mode = this.$route.query.mode
        }
	}
</script>

<template>
	<span>

    <div style="background: #f5f5f5; margin-bottom: 1rem;" class="ui grid">
        <div v-if="getRole.name == 'Admin'" class="ten wide column">
<h5>Step 1</h5>
<p>Firstly, fill the required fields to get your access code to use in Step 2. You can find your client ID and Client Secret at Google Play Console dashboard.</p>
        <form action="https://accounts.google.com/o/oauth2/auth" method="get" target="_blank" id="auth" class="ui form center aligned action">
            <input type="text" name="state" :value='JSON.stringify({"userId": getUser._id,"workspaceId": currentWorkspace._id, "packageName": appId.trim(), "clientId": clientId.trim(), "clientSecret": secret.trim()})' hidden>
            <div class="field">
            <input type="text" placeholder="Client ID" name="client_id" v-model="clientId">
            </div>
            <div class="field">
            <input type="text" placeholder="Client Secret"  v-model="secret">
            </div>
            <input type="text" name="redirect_uri" :value="'urn:ietf:wg:oauth:2.0:oob'" hidden>
            <input type="text" name="response_type" :value="'code'" hidden>
            <input type="text" name="access_type" :value="'offline'" hidden>
            <input type="text" name="prompt" :value="'consent'" hidden>
            <input type="text" name="scope" :value="'https://www.googleapis.com/auth/androidpublisher'" hidden>
            <div class="field">
            <input style="display: inline-block; width: 250px;" name="packageName" v-model="appId" type="text" placeholder="Type your App ID Ex: com.juphy">
            </div>
            <button type="submit" value="Submit" class="ui fluid button" :disabled="(appId.length < 4)">Get Permission </button>
        </form> 
        <h5>Step 2</h5>
        <p>Copy/paste code that given by Google and finish integration successfully.</p>
        <form action="https://api.juphy.com/googleplay/redirect" method="get" target="_blank" id="auth" class="ui form center aligned action">
            <input type="text" name="state" :value='JSON.stringify({"userId": getUser._id,"workspaceId": currentWorkspace._id, "packageName": appId.trim(), "clientId": clientId.trim(), "clientSecret": secret.trim()})' hidden>
            <div class="field">
                <input style="width: 250px;" name="code" v-model="code" type="text" placeholder="Code">
            </div> 
            <button type="submit" value="Submit" class="ui fluid blue button" :disabled="(code.length < 4)">Finish Integration </button>
        </form> 

<!--         <form v-if="getRole.name == 'Admin' && mode != 'test'" id="auth" class="ui form center aligned action" :action=" config.url + '/googleplay/auth'" method="post">

        <input type="text" name="accessToken" v-model="getJwt" hidden>
        <input type="text" name="workspaceId" v-model="currentWorkspace._id" hidden>
        <input style="display: inline-block; width: 250px;" name="packageName" v-model="appId" type="text" placeholder="Type your App ID Ex: com.juphy">
        <button style="display: inline-block;" type="submit" value="Submit" class="ui button" :disabled="(appId.length < 4)">Connect </button>
        
        </form>

        <form v-if="getRole.name == 'Admin' && mode == 'test'" id="auth" class="ui form center aligned action" :action=" 'https://juphy-api.ngrok.io/googleplay/auth'" method="post">

        <input type="text" name="accessToken" v-model="getJwt" hidden>
        <input type="text" name="workspaceId" v-model="currentWorkspace._id" hidden>
        <input style="display: inline-block; width: 250px;" name="packageName" v-model="appId" type="text" placeholder="Type your App ID Ex: com.juphy">
        <button style="display: inline-block;" type="submit" value="Submit" class="ui button" :disabled="(appId.length < 4)">Connect </button>

        </form> -->


        </div>
        <div style="text-align: right;" class="six wide column">

        </div>
        </div>

        <div v-if="!loader && !pages.length" class="ui basic padded segment center aligned">
            <p style="color: #ccc;font-size: 20px;font-style: italic;">
                Don't have any active Google Play Store Application
            </p>
        </div>

        <table v-if="!loader && pages.length" style="padding: 0rem 0.5rem;" class="ui very basic celled table fluid">
            <tbody>
            
            <tr v-for="account in pages" :key="account._id">
                <td><h4 class="ui image header">
                    <img :src="account.avatar" class="ui mini rounded image">
                    <div class="content">
                        {{account.name}}

                    </div>
                </h4></td>
                <td v-if="showEditPageName" >                        
                    <div style="margin-left: 1rem;" class="ui action small input">
                            <input type="text"  v-model="account.name" placeholder="Cannot be empty!">
                            <button class="ui button" @click="updateChannelName(account)">Save</button>
                        </div>
                    </td>
<!--                               <td class="collapsing">
                    <a class="ui basic label">#tw-{{account.screenName}}</a>
                </td> -->
                <td class="collapsing" style="vertical-align: bottom;">


                <div  v-if="account.tags && account.tags.indexOf('5e8e0527817d3903cb610bde') != -1" class="ui compact warning small message" style="width:400px;">
                        <div class="header">Permissions Expired</div>
                        <p>Juphy can't access data for this channel. To regain data access, you have to re-authorize your account's permissions. Remove this one from the list and re-fill the form above.
                        </p>
                    </div>

<!--                     <div v-if="getRole.name == 'Admin' && (account.tags && account.tags.indexOf('5e8e0527817d3903cb610bde') == -1) || (!account.tags)" class="ui fitted toggle checkbox check">
                        
                        <input v-if="account.tags && account.tags.indexOf(tagsByName['Passive']._id) != -1"  @click="update_status($event, account._id)" type="checkbox" :checked="false">
                        <input v-if="!account.tags || account.tags.indexOf(tagsByName['Passive']._id) == -1" @click="update_status($event, account._id)" type="checkbox" :checked="true"> 
                        <label></label>
                        
                    </div> -->
                </td>
                <td class="collapsing">
                    <div style="background: transparent;" class="ui left dropdown icon button">
                        <i class="ellipsis vertical icon"></i>
                        <div class="menu">
                            <div @click="(showEditPageName) ? showEditPageName = false : showEditPageName = true" class="item">Edit</div>
                            <div @click="deleteChannel(account._id)" class="item"> Delete </div>
                        </div>
                    </div>
                </td>
            </tr>
            
            </tbody>
        </table> 
	</span>
</template>


<style scoped >
.ui.table thead th {
    border-bottom: none;
}
.ui.toggle.checkbox input:checked ~ label::before {
    background-color: #8ef2b6 !important;
}
.ui.toggle.checkbox label::before{
    height: 1.9rem;
}
.ui.toggle.checkbox label::after{
    height: 1.9rem;
    width: 1.9rem;
}
.ui.toggle.checkbox input:checked ~ label::after {
    left: 1.6rem;
    box-shadow: 1px 1px 1px #ddd;
}
.ui.toggle.checkbox input {
    height: 1.9rem;
}
.ui.table td.collapsing, .ui.table th.collapsing {
    width: 1px;
    white-space: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/accounts/googlePlay.vue